<div class="container-fluid">
    <div class="row">
        <div *ngFor="let parking of parkings" class="col-md-3">
            <app-parking-list-item [forMerchants]="true" [merchantKey]="merchantKey" [parking]="parking" (onSelect)="onSelect($event)"></app-parking-list-item>
        </div>
    </div>
</div>
